export default __webpack_public_path__ + "static/media/webcam7.159b407e.jfif";